import "@/App.css";
import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VikingLanding from "@/pages/VikingLanding";
import AdminTweaks from "@/pages/AdminTweaks";
import { TweaksProvider } from "@/context/TweaksContext";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", background: "#04070b", display: "flex", alignItems: "center", justifyContent: "center", color: "#fef3c7" }}>
          <p style={{ fontFamily: "Manrope, sans-serif", fontSize: "14px", opacity: 0.6 }}>Algo salió mal. Recarga la página.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <ErrorBoundary>
        <TweaksProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<VikingLanding />} />
              <Route path="/panelAdmin" element={<AdminTweaks />} />
            </Routes>
          </BrowserRouter>
        </TweaksProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
